export default __webpack_public_path__ + "static/media/sub-category-coworking-ConferenceRoom.b8ee3e08.jpg";